module.exports = __webpack_public_path__ + "img/super06.4fb2e547.png";